import React from "react";
import ClosedBadge from "./ClosedBadge";

// Old-design provider card: clickable while open, dimmed with a "Closed"
// badge and no click handler while closed.
const ClosableCard = ({ closed, onClick, style, children, ...props }) => (
  <div
    {...props}
    onClick={closed ? undefined : onClick}
    aria-disabled={closed ? "true" : undefined}
    style={
      closed
        ? { position: "relative", cursor: "not-allowed", opacity: 0.85, ...style }
        : style
    }
  >
    {closed && <ClosedBadge />}
    {children}
  </div>
);

export default ClosableCard;
